import $ from "jquery";
import {fetchStaffs} from "../staff";

export async function getColumnsDatatable(Twig,filteredDoctorList) {
    if (!filteredDoctorList || filteredDoctorList.length === 0) {
        return [{
            name: 'empty',
            title: 'Нет доступных врачей',
            orderable: false,
            searchable: false,
            width: "100%",
            render: ((data, type, full, meta) => {
                return '<div class="scheduleDateBox">' +
                    '<strong>' +
                    '<div class="alert alert-warning" role="alert">Нет доступных врачей для отображения расписания.</div>' +
                    '</strong>' +
                    '</div>'
            })
        }];
    }

    let columns = [];
    let salonsList = api.salonsList();
    columns.push({
        orderable: false,
        searchable: false,
        data: 't',
        name: 't',
        title: '',
        width: "10%",
        visible: false, /* <== скрыли колонку с датами 08.2023 */
        render: ((data, type, full, meta) => {
            let scheduleDate = new Date(data);
            let daysWeek = [
                'Вс',
                'Пн',
                'Вт',
                'Ср',
                'Чв',
                'Пт',
                'Сб'
            ];
            let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
            let n = scheduleDate.getDay();
            let scheduleDateHours = scheduleDate.getHours();
            let scheduleDateMinutes = scheduleDate.getMinutes();
            if (scheduleDateHours < 10) {
                scheduleDateHours = "0" + scheduleDateHours;
            }
            if (scheduleDateMinutes < 10) {
                scheduleDateMinutes = "0" + scheduleDateMinutes;
            }

            let scheduleOnlyTime = scheduleDateHours + ":" + scheduleDateMinutes;

            if (scheduleDate.getHours() === 11) {


                return '<div class="scheduleDateBox">' +
                    '<strong>' +
                    scheduleDate.toLocaleDateString('ru-KZ', {year: 'numeric', month: 'long', day: 'numeric'}) + '' +
                    '</strong>' +
                    '</div>'
            }

            /*if (scheduleDate.getHours() === 11){
                return '<div class="scheduleDateBox">' +
                    '<div class="scheduleDateCalendar">' +
                    '<span class="scheduleDateBox__month">'+months[scheduleDate.getMonth()]+'</span>' +
                    '<span class="scheduleDateBox__date">'+scheduleDate.getDate()+'</span>' +
                    '<span class="scheduleDateBox__daysWeek">'+daysWeek[n]+'</span>' +
                    '</div>' +
                    '<span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span>' +
                    '</div>'
            } else {
                return '<div class="scheduleDateBox scheduleDateBoxSingle"><span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span></div>'
            }*/

        })
    });


    self = this;




    $('#databaseMySchedule').css({"width": "200px"});

    const fetchStaffsArray = await fetchStaffs({status: 'all'});
    const staffs = {};
    fetchStaffsArray.data.forEach(item => {
        staffs[item.staff_id] = item;
    });
    let badges = {};

    filteredDoctorList.forEach((item) => {
        self = this;
        let currentSalon = item.currentSalonId;
        badges[item.StaffID] = 0;
        /*  let colTitle = '<div class="colTitleBox"><span class="colTitle__salon">'+item.StoreCode+'</span><span class="colTitle">'+item.Name.replace(/(\S+) (\S+) (\S+)/, "$1<br> $2<br> $3")+'</span></div>';*/
        let colTitle = '<div class="colTitleBox"><span class="colTitle">' + item.Name.replace(/(\S+) (\S+) (\S+)/, "$1<br> $2<br> $3") + '</span></div>';
        let doctorId = item.StaffID;
        columns.push({
            data: 'd' + item.StaffID,
            name: String(item.currentSalonId),
            title: colTitle,
            searchable: false,
            orderable: false,
            width: "10%",
            'createdCell': function (td, cellData, rowData, row, col) {
                let cellId = 'cell-' + item.StaffID + '-' + new Date(rowData.t).getTime()
                $(td).attr('id', cellId);
            },
            render: ((data, type, full, meta) => {
                /*!!! ячейка времени настройки !!!*/
                //ID для ячейки = ID  доктора + timestamp ячейки
                let timeItemID = doctorId + '-' + new Date(full.t).getTime();

                //узнаем контроллер
                let controllerName = $('.database__main').attr("id");

                let doctorDate = new Date(full.t);

                let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

                let doctorTimeHours = new Date(full.t).toLocaleTimeString(
                    "ru-RU",
                    {
                        minute: '2-digit',
                        hour: '2-digit'
                    });

                //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
                let timePassed = "";
                let timePassedDisabled = "";
                if (new Date() > doctorDate) {
                    timePassed = 'time_passed';
                    timePassedDisabled = 'disabled="disabled"'
                }

                let orderDateTimeFrom = doctorDate.getTime();
                let orderDateTimeTo = Number(orderDateTimeFrom) + 30 * 60 * 1000;

                //это дата
                let orderDateDayToUser = new Date(orderDateTimeFrom).toLocaleDateString(
                    'ru-RU',
                    {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    });

                //время от и до
                let orderDateFromTimeToUser = new Date(orderDateTimeFrom).toLocaleTimeString(
                    'ru-RU',
                    {
                        hour: "2-digit",
                        minute: "2-digit"
                    });
                let orderDateToTimeToUser = new Date(Number(orderDateTimeTo)).toLocaleTimeString(
                    'ru-RU',
                    {
                        hour: "2-digit",
                        minute: "2-digit"
                    });

                //let informationBlock = '';

                //вытаскиваем коды салонов
                let currentDoctorSalon = 'выходной';
                if (data.SalonId !== '') {
                    const findSalon = salonsList.find(item => item.store_id == data.SalonId);
                    currentDoctorSalon = findSalon.store_cod
                }

                //создаем уникальный ID
                let unitId = doctorId + '' + meta.col + '' + meta.row;

                /* выходной */
                if (data.Reason === 'offDays') {
                    let content = Twig.twig({ref: "schedule-item-offdays"}).render({
                        'currentDoctorSalon': currentDoctorSalon,
                        'doctorDate': doctorDate.getDate(),
                        'doctorTimeHours': doctorTimeHours,
                        'monthName': months[doctorDate.getMonth()],
                        'timeItemID': timeItemID,
                        'timePassed': timePassed,
                        'unitId': unitId,
                    });
                    return content
                }

                /* рабочее свободное время */
                if (data.Reason === null && data.ClientsCustomerID === null && data.ClientsStaffID === null) {

                    let content = Twig.twig({ref: "schedule-item-free"}).render({
                        'clientsCustomerID': data.ClientsCustomerID,
                        'controllerName': controllerName,
                        'currentDoctorSalon': currentDoctorSalon,
                        'doctorDate': doctorDate.getDate(),
                        'doctorTimeHours': doctorTimeHours,
                        'itemMinPatientAge': item.MinPatientAge,
                        'itemName': item.Name,
                        'salon_id': data.SalonId,
                        'itemStaffID': item.StaffID,
                        'metaRow': meta.row,
                        'monthName': months[doctorDate.getMonth()],
                        'orderDateDayToUser': orderDateDayToUser,
                        'orderDateFromTimeToUser': orderDateFromTimeToUser,
                        'orderDateToTimeToUser': orderDateToTimeToUser,
                        'orderDateTimeFrom': orderDateTimeFrom,
                        'orderDateTimeTo': orderDateTimeTo,
                        'timePassed': timePassed,
                        'unitId': unitId,
                        'timeItemID': timeItemID,
                        // 'informationBlock': informationBlock,
                    });
                    return content
                }

                //рабочее занятое время
                if (data.Reason !== 'offDays' && data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'BUSINESS') {
                    let selfAppointment = parseInt(JSON.parse(data.Notes).selfAppointment);
                    let manager = staffs[JSON.parse(data.Notes).manager];
                    let managerName = 'Не известно';

                    if (manager) {
                        managerName = manager.description.name;
                    } else if (selfAppointment) {
                        managerName = 'Самостоятельная Запись';
                    }

                    let clientName = data.Reason.split(":");
                    clientName = clientName[1];
                    let diagnosticType = '';
                    let isApprovedText = '';
                    let amauntIcon = '';
                    let switchStatus = '';
                    let statusDoctorClass = '';
                    if (data.IsApproved) {
                        isApprovedText = 'подтвержден';
                        statusDoctorClass = 'isApproved'
                        switchStatus = 'checked'
                    } else {
                        isApprovedText = 'не подтвержден';
                        statusDoctorClass = 'noApproved'
                    }
                    diagnosticType = global.globalFuncs.DiagnosticTypes.getDiagnosticTypeTitle(data.DiagnosticType)

                    let notes = (data.Notes).replace(/['"{}]/g, '').split(",");
                    let doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                    let doctorScheduleLargeComment = '';
                    let doctorScheduleVisit = "";
                    let doctorScheduleWhoWrote = "";
                    let doctorScheduleWhoWroteStatus = '';
                    let doctorScheduleComeFrom = '';
                    let doctorSchedulePatientAge = '';
                    notes.forEach((item) => {
                        let notesData = item.split(":");
                        if (notesData[0].trim() === 'comment') {
                            if (notesData[1] === '') {
                                doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                            } else {
                                doctorScheduleComment = notesData[1].trim();
                                doctorScheduleComment = doctorScheduleComment.replaceAll('|', '<br>');
                                if (doctorScheduleComment.length > 50) {
                                    doctorScheduleLargeComment = 'datatableDoctorOrderInfo__comment--large'
                                }
                            }
                        }
                        if (notesData[0] === 'visit') {
                            doctorScheduleVisit = global.globalFuncs.ScheduleVisit.getVisitTypeTitle(notesData[1]) || notesData[1]
                        }
                        if (notesData[0] === 'doctor') {
                            doctorScheduleWhoWroteStatus = 'врач';
                            doctorScheduleWhoWrote = notesData[1];
                            doctorScheduleComeFrom = 'салон'
                        }
                        if (notesData[0] === 'manager') {
                            doctorScheduleWhoWroteStatus = 'менеджер';
                            doctorScheduleWhoWrote = notesData[1];
                            doctorScheduleComeFrom = 'салон'
                        }
                        if (notesData[0] === 'ref') {
                            doctorScheduleWhoWroteStatus = 'пациент';
                            doctorScheduleComeFrom = notesData[1]
                        }
                        if (notesData[0] === 'clientAge') {
                            doctorSchedulePatientAge = notesData[1]
                        }
                    });

                    //start - end visit
                    let orderStart = new Date(data.Start).toLocaleTimeString(
                        'ru-KZ',
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        });
                    let orderEnd = new Date(data.Finish).toLocaleTimeString(
                        'ru-KZ',
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        });

                    if (data.PrepayAmount !== null) {
                        amauntIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon amauntIcon"><circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line></svg>'
                    }
                    amauntIcon;
                    let prepayAmountText = data.PrepayAmount;
                    if (prepayAmountText === null) {
                        prepayAmountText = '';
                    }

                    let content = Twig.twig({ref: "schedule-item-busy"}).render({
                        'clientsCustomerID': data.ClientsCustomerID,
                        'managerName': managerName,
                        'clientName': clientName,
                        'controllerName': controllerName,
                        'currentDoctorSalon': currentDoctorSalon,
                        'dataIsApproved': data.IsApproved,
                        'dataID': data.ID,
                        'diagnosticType': diagnosticType,
                        'doctorDate': doctorDate.getDate(),
                        'doctorScheduleComment': doctorScheduleComment,
                        'doctorScheduleLargeComment': doctorScheduleLargeComment,
                        'doctorScheduleVisit': doctorScheduleVisit,
                        'doctorTimeHours': doctorTimeHours,
                        'isApprovedText': isApprovedText,
                        'itemName': item.Name,
                        //'itemStaffID': item.StaffID,
                        'metaRow': meta.row,
                        'monthName': months[doctorDate.getMonth()],
                        'orderDateDayToUser': orderDateDayToUser,
                        'orderStart': orderStart,
                        'orderEnd': orderEnd,
                        'patientDateBirth': '',
                        'patientClientAge': '',
                        'prepayAmountText': prepayAmountText,
                        'statusDoctorClass': statusDoctorClass,
                        'switchStatus': switchStatus,
                        'timeItemID': timeItemID,
                        'timePassed': timePassed,
                        'timePassedDisabled': timePassedDisabled,
                        'unitId': unitId,
                    });
                    return content
                }

                //рабочее заблокированное время
                if (data.Reason !== 'offDays' && data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'PERSONAL') {
                    let content = Twig.twig({ref: "schedule-item-block"}).render({
                        'clientsCustomerID': data.ClientsCustomerID,
                        'controllerName': controllerName,
                        'currentDoctorSalon': currentDoctorSalon,
                        'doctorDate': doctorDate.getDate(),
                        'dataID': data.ID,
                        'dataReason': data.Reason,
                        'doctorTimeHours': doctorTimeHours,
                        'itemName': item.Name,
                        'monthName': months[doctorDate.getMonth()],
                        'orderDateDayToUser': orderDateDayToUser,
                        'orderDateFromTimeToUser': orderDateFromTimeToUser,
                        'orderDateToTimeToUser': orderDateToTimeToUser,
                        'timeItemID': timeItemID,
                        'timePassed': timePassed,
                        'unitId': unitId,
                    });
                    return content

                }
            })
        });


    })
    return columns
}


export async function drawCallback() {
    let api = this.api();
    let rows = api.rows({page: 'current'}).nodes();
    let last = null;
    let dateGroups = {};

    console.log("api.column('t:name', {page: 'current'}).data()",api.column('t:name', {page: 'current'}).data())
    api.column('t:name', {page: 'current'}).data().each(function (group, i) {
        let date = new Date(group);
        let dateString = date.toLocaleDateString('ru-KZ');

        if (!dateGroups[dateString]) {
            dateGroups[dateString] = [];
        }
        dateGroups[dateString].push(i);
    });


    api.column('t:name', {page: 'current'}).data().each(function (group, i) {
        let date = new Date(group);
        let dateString = date.toLocaleDateString('ru-KZ');
        let isCurrentDate = dateString === new Date().toLocaleDateString('ru-KZ');
        if (last !== dateString) {
            $(rows).eq(i).before(
                `<tr class="schedule-date-row ${isCurrentDate ? 'schedule-date-row__current-date':''}" data-date="${dateString}">
                <td colspan="${api.columns().nodes().length}" style="cursor: pointer;">
                <span class="expand-icon">[-]</span>
                ${isCurrentDate ? '<span class="badge bg-success">Сегодня</span>' : ''}
                ${date.toLocaleDateString('ru-KZ', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    weekday: 'long'
                })}
                </td></tr>`
            );
            last = dateString;
        }
    });
    $('.schedule-date-row')
        .off('click').on('click', function () {
            let dateString = $(this).data('date');
            let expandIcon = $(this).find('.expand-icon');
            let isCollapsed = expandIcon.text() === '[+]';

            expandIcon.text(isCollapsed ? '[-]' : '[+]');

            dateGroups[dateString].forEach(function (rowIdx) {
                $(rows[rowIdx]).toggle(isCollapsed);
            });
        })
        .each(function() {
            let dateString = $(this).data('date');
            let isCurrentDate = dateString === new Date().toLocaleDateString('ru-KZ');

            if (isCurrentDate){
                $(this).find('.expand-icon').text('[-]');

            }else{
                $(this).find('.expand-icon').text('[+]');

            }
            dateGroups[dateString].forEach(function(rowIdx) {
                $(rows[rowIdx]).toggle(isCurrentDate);
            });
        });

}